module.exports = __webpack_public_path__ + "img/1544416855.2f6519c2.jpg";